<template>
  <div class="pages-login">
    <div class="flex flex-col h-full justify-center items-center">
      <!--登录框界面-开始-->
      <div class="bg-white z-10 rounded-3xl shadow-lg flex px-20 py-24">
        <div class="flex-1 w-96 h-80 justify-center items-center pr-10">
          <img src="https://admin.playedu.xyz/assets/icon-ef68003c.png" alt=""/>
        </div>
        <div class="flex-1 w-96 h-80 ">
          <h1 class="text-3xl pages-login-title">系统登录</h1>
          <div class="py-12">
            <el-form ref="form">
              <el-form-item class="mb-10">
                <el-input placeholder="输入账号" v-model="username"></el-input>
              </el-form-item>
              <el-form-item class="mb-10">
                <el-input placeholder="输入密码" type="password" v-model="password"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="w-full h-14" @click="handleLogin">立即登录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!--登录框界面-结束-->
      <div class="py-10 z-10">
        <p class="text-sm text-gray-500">Copyright &copy; 2023 Hankun Company Inc.</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "login",
  /**
   * 调用组建
   * @type {Object}
   */
  components: {},
  /**
   * 组建属性
   * @type {Object}
   */
  props: {},
  /**
   * 数据字段
   * @return {[type]} [description]
   */
  data() {
    return {
      username: "",
      password: ""
    };
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {
    isLogin() {
      return this.$cloud.isLogin()
    }
  },
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {},
  /**
   * 页面创建时
   * @return {[type]} [description]
   */
  created() {

  },
  /**
   * 页面加载时
   * @return {[type]} [description]
   */
  mounted() {
    if (this.isLogin) {
      this.$cloud.go("/")
    }
  },
  /**
   * 页面调用函数
   * @type {Object}
   */
  methods: {
    handleLogin() {
      let {username, password} = this;
      this.$cloud.login("login/index", {
        username,
        password
      }).then(data => {
        console.log("处理登录成功", data)
        this.$cloud.go("/")
      })
    }
  }
};
</script>
<style lang="scss">
.pages-login {
  width: 100%;
  height: 100%;

  .el-input .el-input__inner {
    border-radius: 6px !important;
    height: 54px !important;
    line-height: 54px !important; // 将高度设置为 50px
  }
}

.pages-login::before {
  content: "";
  position: absolute;
  z-index: 1;
  background: #ff4d4f;
  top: 10%;
  left: 50%;
  width: 150%;
  height: 100%;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.pages-login-title {
  width: 120px;
  padding-bottom: 10px;
  border-bottom: 4px solid #ff4d4f;
}
</style>